// extracted by mini-css-extract-plugin
export default {"-large":"s24dsZ_lKtZK3sYTHpFw","loadingContainer":"GzPCogdVRjKTiSJ35Inb","waveformContainer":"K68ahQJ2n1xvC41jzpQw","wavesurferContainer":"_NxVT6AdBuOfSZGH1ByA"};